import { observer } from 'mobx-react';
import React from 'react';

import { Formatter } from '../../../Shared/utils/formatter';
import { Text } from '../text'
import * as styles from './summary-table.less';

type SummaryType = {
    name: string;
    amount: number;
}

export type SummaryTableType = {
    gifts: Array<SummaryType>;
    totalAmount: number;
}

export const SummaryTable = observer(({ gifts, totalAmount }: SummaryTableType) => {
    const currencySymbol = '$';

    const table = gifts.map(gift => {
        const { name, amount } = gift;
        return (
            <div className={styles.row} key={`Fund-${name}`}>
                <div className={styles.fundName}>{name}</div>
                <div className={styles.amount}>{currencySymbol}{Formatter.formatNumberForDisplay(amount, 2)}</div>
            </div>
        )
    })
    
    return (
        <div className={styles.table}>
            {table}
            <div className={styles.total}>
                <div><Text>Total</Text>: </div>
                <div className={styles.totalAmount}>{currencySymbol}{Formatter.formatNumberForDisplay(totalAmount, 2)}</div>
            </div>
        </div>
    );
})